<template></template>
<script>
export default {
  data() {
    return {
      notify: ''
    }
  },

  computed: {
    token() {
      return this.$route.params.token
    }
  },

  created() {
    this.$http
      .get(`${this.$api.get_client_ip}`, {})
      .then((res) => {
        localStorage.setItem('client_ip', JSON.stringify(res.data.ip))
        this.doLogin()
      })
      .catch((error) => {
        localStorage.setItem('client_ip', JSON.stringify(''))
        this.doLogin()
      })

    localStorage.removeItem('userInfo')
    localStorage.setItem('tokenPortal', this.$route.params.token)
    localStorage.setItem('isGenerate', this.$route.query.isGenerate)
  },

  methods: {
    doLogin() {
      this.$http
        .get(`${this.$api.endpoint}/profile`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          if (res.data.status === true) {
            const data = res.data.message.data
            data.token = this.token

            let initial = data.full_name
              .split(' ')
              .map((n, i, a) => (i === 0 || i + 1 === a.length ? n[0] : null))
              .join('')

            // data.photoURL = `https://via.placeholder.com/40/0000FF/FFFFFF?text=${initial}`
            data.photoURL = `https://placehold.jp/16/499fd8/ffffff/40x40.png?text=${initial}`
            this.$vs.loading.close('#loginBtn > .con-vs-loading')
            this.$store.dispatch('updateUserInfo', data)
            // this.$router.push('/tracking')

            if (data.privilege == 3) localStorage.setItem('infoSscAdmin', true)
            else if (data.privilege == 4)
              localStorage.setItem('emailVerifAttention', true)

            window.location.href = '/v2/tracking'
          }
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    }
  }
}
</script>
